export default "<div #map\r\n     id=\"map\"\r\n></div>\r\n";